var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#22c55e",
    viewBox: "0 0 24 25",
    className: "w-6 h-6 fill-[#22C55E] shrink-0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 12.196c-1.152.477-2.072.906-2.76 1.288-.681.382-1.213.76-1.595 1.136-.375.375-.754.903-1.136 1.584-.382.68-.818 1.613-1.309 2.796h-.391c-.497-1.183-.936-2.115-1.318-2.796-.382-.68-.757-1.209-1.127-1.584-.382-.376-.917-.754-1.604-1.136-.681-.382-1.601-.811-2.76-1.288v-.392c1.165-.477 2.088-.906 2.77-1.288.687-.382 1.219-.76 1.594-1.136.37-.375.745-.903 1.127-1.584.382-.68.821-1.613 1.318-2.796h.392c.49 1.183.926 2.115 1.308 2.796.382.68.76 1.209 1.136 1.584.37.376.895.754 1.576 1.136.688.382 1.614.811 2.779 1.288v.392z",
    className: "",
    "data-label": "path"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenStar);
export default __webpack_public_path__ + "static/media/greenStar.f96ce87a2d6281a2a11b557a18570acd.svg";
export { ForwardRef as ReactComponent };